var React = require('react');

function Star (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10 0L10.7855 4.39081C11.2296 6.87329 13.1786 8.8131 15.6632 9.2454L20 10L15.6289 10.7868C13.1617 11.2308 11.2306 13.1619 10.7866 15.6291L10 20L9.24524 15.6631C8.81288 13.1787 6.8732 11.2298 4.39088 10.7857L0 10L4.35672 9.24641C6.85627 8.81406 8.81385 6.85652 9.24626 4.35698L10 0Z","fill":"white"}));
}

Star.defaultProps = {"className":"star","width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = Star;

Star.default = Star;
